import { render, staticRenderFns } from "./AddComponentCard.vue?vue&type=template&id=df8513a0&scoped=true&"
import script from "./AddComponentCard.vue?vue&type=script&lang=js&"
export * from "./AddComponentCard.vue?vue&type=script&lang=js&"
import style0 from "./AddComponentCard.vue?vue&type=style&index=0&id=df8513a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8513a0",
  null
  
)

export default component.exports